import Vue from 'vue'
import {
  DEFAULT_COLOR,
  DEFAULT_CONTENT_WIDTH_TYPE,
  REGION
} from '@/store/mutation-types'

const app = {
  state: {
    device: 'desktop',
    contentWidth: '',
    color: null,
    region: '重庆市'
  },
  mutations: {
    TOGGLE_COLOR: (state, color) => {
      Vue.ls.set(DEFAULT_COLOR, color)
      state.color = color
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    TOGGLE_CONTENT_WIDTH: (state, type) => {
      Vue.ls.set(DEFAULT_CONTENT_WIDTH_TYPE, type)
      state.contentWidth = type
    },
    SET_REGION: (state, region) => {
      Vue.ls.set(REGION, region)
      state.region = region
    }
  },
  actions: {
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    ToggleContentWidth({ commit }, type) {
      commit('TOGGLE_CONTENT_WIDTH', type)
    },
    ToggleColor({ commit }, color) {
      commit('TOGGLE_COLOR', color)
    },
    SetRegion({ commit }, region) {
      commit('SET_REGION', region)
    }
  }
}

export default app
